<template>
  <div
    class="fabric-modal-outer tw-fixed tw-top-0 tw-left-0 tw-pl-0
      tw-transition-opacity tw-duration-150 ease-linear
      tw-overflow-x-hidden tw-overflow-y-auto show tw-w-full tw-h-full tw-z-modal"
    :class="[
      (isHidden ? 'opacity-0' : 'opacity-100'),
      (isStatic ? 'modal-static' : 'modal-root'),
    ]"
    @click="onClickOut"
  >
    <div
      class="tw-flex tw-relative tw-items-center
        tw-transition-transform tw-duration-500 tw-ease-out
        tw-m-2 smModal:tw-my-7 smModal:tw-mx-auto"
      :class="[
        sizeStyle,
        dialogClass,
        overflowStyle,
        {
          'tw-min-h-modal': centered,
          'tw--translate-y-72': isHidden,
        },
      ]"
      :data-label="'modal-dialog modal-dialog-' + size"
    >
      <slot v-if="!!isStatic"></slot>
    </div>
    <div class="tw-hidden tw-w-4/5 tw-max-w-none tw-min-w-[30%]"></div>
  </div>
</template>

<script>

  export default {
    name: 'FabricModalRack',
    props: {
      isStatic: {
        type: Boolean,
        default: false,
      },
      centered: {
        type: Boolean,
        default: false,
      },
      dialogClass: {
        type: String,
        default: ''
      },
      isHidden: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'xl',
      },
      onClickOut: {
        type: Function,
        default: () => {},
      },
      overflowTypeX: {
        type: String,
        default: 'hidden',
      },
      overflowTypeY: {
        type: String,
        default: 'auto',
      },
    },
    data() {
      return {
      }
    },
    computed: {
      overflowStyle(){
        return `tw-overflow-x-${this.overflowTypeX} tw-overflow-y-${this.overflowTypeY}`
      },
      sizeStyle() {
        const sizeMapping = {
          // xl normal:  tw-w-auto  mlModal:tw-max-w-[800px] xl:tw-max-w-[1140px]
          xl: 'tw-max-w-none tw-w-auto smModal:tw-w-[86%]',
          lg: 'tw-w-auto smModal:tw-max-w-[500px] mlModal:tw-max-w-[800px]',
          md: 'tw-w-auto smModal:tw-max-w-[500px]',
        }
        return sizeMapping[this.size]
      },
      usedStyle() {
        return {
          xl: 'tw-w-auto tw-max-w-none tw-w-[86%] mlModal:tw-max-w-[800px] xl:tw-max-w-[1140px] tw-w-auto smModal:tw-w-[86%]',
          lg: 'tw-w-auto mlModal:tw-max-w-[800px]',
          md: 'tw-w-auto smModal:tw-max-w-[300px] smModal:tw-max-w-[500px]',
          common: 'tw-overflow-hidden',
        }
      }
    },
  }
</script>
